import { Checkbox, MultiSelect, Select } from '@mantine/core'

import { useTranslation } from '@flecto/translations'

import { useOnboardingNavigation } from '../../hooks/useOnboardingNavigation'
import { useOnboardingSelectOptions } from '../../hooks/useOnboardingSelectOptions'
import { useFormContext } from './FormOnboarding'
import { StepWrapper } from './StepWrapper'

export function Step03() {
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })
  const { nextStep } = useOnboardingNavigation()
  const {
    businessCategories,
    avgBookingsPerMonth,
    systemsToReplace,
    flectoProductsInterestedOn,
  } = useOnboardingSelectOptions()

  const form = useFormContext()

  const handleNext = () => {
    form.validate()

    const isValid =
      form.isValid('step_business_info.avg_bookings_per_month') &&
      form.isValid('step_business_info.business_category') &&
      form.isValid('step_business_info.systems_to_replace') &&
      form.isValid('step_business_info.flecto_products_interested_on')

    if (!isValid) {
      return
    }

    form.clearErrors()
    nextStep()
  }

  return (
    <StepWrapper
      stepNumber={3}
      title={t('steps.business_info.title')}
      description={t('steps.business_info.description')}
      onNextStep={handleNext}
    >
      <Select
        {...form.getInputProps('step_business_info.business_category')}
        label={t('form_labels.business_category')}
        placeholder={t('form_placeholders.pick_one')}
        data={businessCategories.data}
        disabled={businessCategories.isLoading}
        withAsterisk
        mb='md'
      />
      <Select
        {...form.getInputProps('step_business_info.avg_bookings_per_month')}
        label={t('form_labels.avg_bookings_per_month')}
        placeholder={t('form_placeholders.pick_one')}
        data={avgBookingsPerMonth}
        withAsterisk
        mb='md'
      />
      <MultiSelect
        {...form.getInputProps('step_business_info.systems_to_replace')}
        label={t('form_labels.systems_to_replace')}
        placeholder={t('form_placeholders.pick_multiple')}
        data={systemsToReplace}
        withAsterisk
        mb='md'
      />
      <Checkbox.Group
        {...form.getInputProps(
          'step_business_info.flecto_products_interested_on'
        )}
        label={t('form_labels.flecto_products_interested_on')}
        description={t('form_placeholders.pick_multiple')}
      >
        {flectoProductsInterestedOn.map((item) => (
          <Checkbox
            key={item.value}
            value={item.value}
            label={item.label}
            size='md'
            mb='sm'
          />
        ))}
      </Checkbox.Group>
    </StepWrapper>
  )
}
